import 'react-app-polyfill/ie11'; // For IE11 support
import 'react-app-polyfill/stable'; // For other browsers
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import AddCreditCard, { IAddCreditCardProps } from "./AddCreditCard";
import reportWebVitals from "./reportWebVitals";
import Health from "./Health";
import CheckoutErrorPage from "./CheckoutErrorPage";
import HandleRedirectPaymentChallenge from './HandleRedirectPaymentChallenge';
import $ from "jquery";

const environment = getEnvironmentFromUrl(window.location.href);
const addCcProps = ReadAddCreditCardProp(window.location.href);

if (new URL(window.location.href).pathname == "/health") {
  ReactDOM.render(
    <React.StrictMode>
      <Health />
    </React.StrictMode>,
    document.getElementById("root")
  );
} else if (new URL(window.location.href).pathname == "/error") {
  ReactDOM.render(
    <React.StrictMode>
      <CheckoutErrorPage />
    </React.StrictMode>,
    document.getElementById("root")
  );
} else if (new URL(window.location.href).pathname.includes("/challengeui")) {
  const pathSegments = new URL(window.location.href).pathname.split("/");
  // Default to v1 if "v2" is not present in the URL path
  const version = pathSegments.includes("v2") ? "v2" : "v1";
  const env = getEnvironmentFromUrl(window.location.href);

  // Dynamically import the correct version to enable code splitting
  const ChallengeProtocolPromise = version === "v2"
    ? import("./v2/challengeui/challengeProtocol").then(module => module.ChallengeProtocol)
    : import("./v1/challengeui/challengeProtocol").then(module => module.ChallengeProtocol);

  ChallengeProtocolPromise.then(ChallengeProtocol => {
    ReactDOM.render(
      <React.StrictMode>
        <ChallengeProtocol env={env} />
      </React.StrictMode>,
      document.getElementById("root")
    );
  }).catch((error) => {
    console.error("Failed to load ChallengeProtocol", error);
    ReactDOM.render(
      <React.StrictMode>
        <div>Unable to load challenge</div>
      </React.StrictMode>,
      document.getElementById("root")
    );
  });
} else if (/^\/challenge\/[^/]+$/.test(new URL(window.location.href).pathname)) { // matches /challenge/{sessionId}
  const sessionId = new URL(window.location.href).pathname.split("/")[2];
  ReactDOM.render(
    <>
      <div id="customHeader"></div>
      <HandleRedirectPaymentChallenge
        sessionId={sessionId}
        env={environment}
      />
      <div id="customFooter"></div>
    </>,
    document.getElementById("root")
  );
  addHeaderFooter();
} else if (new URL(window.location.href).pathname.includes("/addCard")) {
  addHeaderFooter();
  ReactDOM.render(
    <React.StrictMode>
      <body>
          <div id="customHeader"></div>
          {/* generate the green id, send it to risk to fingerprint (it will be javascript) and pass that along */}
          <main>
          <AddCreditCard
            env={addCcProps.env}
            sessionId={addCcProps.sessionId}
            country={addCcProps.country}
            language={addCcProps.language}
            partner={addCcProps.partner}
            paymentType={addCcProps.paymentType}
            paymentFamily={addCcProps.paymentFamily}
            scenario={addCcProps.scenario}
          />
          </main>
          <div id="customFooter"></div>
      </body>
    </React.StrictMode>,
    document.getElementById("root")
  );
} else {
  // The 3rd-party guest-checkout route (/payment-providers/{provider}/checkout(s)/{id}/start)
  // has been discontinued. Any URL that doesn't match the routes above renders 404.
  ReactDOM.render(
    <React.StrictMode>
      <div>404 Not Found :(</div>
    </React.StrictMode>,
    document.getElementById("root")
  );
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

function addHeaderFooter () {
  <script src="http://ajax.googleapis.com/ajax/libs/jquery/3.7.1/jquery.min.js"></script>

  $(document).ready(function() {
    $.ajax({
      url: "https://uhf.microsoft.com/us/shell/xml/MSPayCard?headerid=MSPayCardHeader&footerid=MSPayCardFooter",
      method: 'GET',
      dataType: "xml",
    }).done((msg) => {
      const responsexml = msg;
      const cssIncludes = $(responsexml).find("cssIncludes")[0].childNodes[1] as CDATASection;
      const trimCssData = cssIncludes.data.trim();
      const styles = $.parseHTML(trimCssData);
      $("head").append(styles);

      const headerHtml = ($(responsexml).find("headerHtml")[0].childNodes[1] as CDATASection).data.trim();
      (document.getElementById("customHeader") as HTMLFormElement).innerHTML = headerHtml;

      const footerHtml = ($(responsexml).find("footerHtml")[0].childNodes[1] as CDATASection).data.trim();
      (document.getElementById("customFooter") as HTMLFormElement).innerHTML = footerHtml;
    });
  });
}

function ReadAddCreditCardProp(href: string): IAddCreditCardProps {
  // href example:
  //  https://pay.microsoft.com/anonymous?sessionId=6b1457bf-08cf-44a4-bc52-3028113df9d8&country=us&language=en-us&parnter=xboxsettings

  const parts = href.split("/");
  const queryParams = new URL(href).searchParams;
  const language = queryParams.get("language") ?? "en-us";
  const country = queryParams.get("country") ?? "us";
  const sessionId = queryParams.get("sessionId") ?? "";
  const partner = queryParams.get("partner") ?? "xboxsettings";
  const paymentType = queryParams.get("type") ?? "amex,visa,mc,discover";
  const paymentFamily = queryParams.get("paymentFamily") ?? "credit_card";
  const scenario = queryParams.get("scenario") ?? "secondScreenAddPi";

  const env = getEnvironmentFromUrl(href);

  return {
    country: country,
    env: env,
    language: language,
    sessionId: sessionId,
    partner: partner,
    paymentType: paymentType,
    paymentFamily: paymentFamily,
    scenario: scenario,
  };
}

function getEnvironmentFromUrl(href: string): string {
  let env = "int";
  switch (new URL(href).hostname) {
    case "payint.microsoft.com":
      env = "int";
      break;
    case "payppe.microsoft.com":
      env = "ppe";
      break;
    case "pay.microsoft.com":
      env = "prod";
      break;
  }

  return env;
}

